import {
  Box,
  Button,
  Chip,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { Eye, Gear } from '@phosphor-icons/react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FormsService } from '../../../../service/FormService';
import useFlowsStore from '../../../../store/storeFlows';
import { useFormBuilder } from '../../Context/FormBuilderContext';
import PublishModal from '../../PublishedModal/PublishedModal';
import { ActionTypes } from '../../Reducer';
import { PreviewModal } from '../PreviewModal/PreviewModal';
import ShareFormModal from '../ShareModal/ShareModal';

export function FormBuilderHeader() {
  const { flows } = useFlowsStore(state => state);
  const location = useLocation();
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);

  const {
    state,
    dispatch,
    setSettingsFormMode,
    setSelectNode,
  } = useFormBuilder();

  async function handleActiveFlows(event: any) {
    const selectedFlows = event.target.value as string[];

    const response = await FormsService.inputsOutputs({
      activeFlows: selectedFlows,
    });

    dispatch({
      type: ActionTypes.UPDATE_ACTIVE_FLOWS,
      payload: {
        activeFlows: selectedFlows,
        varInputNodes: response.data.varInputNode,
        varOutputNodes: response.data.varOutputNode,
      },
    });
  }

  const filteredFlows = location.search?.includes('?spaceId=')
    ? flows?.filter(
        flow => flow?.spaceId === location.search?.split('?spaceId=')[1],
      )
    : flows?.filter(
        flow => flow.spaceName === null || (!flow.spaceName && !flow.spaceId),
      );

  return (
    <>
      <div
        style={{
          background: 'white',
          padding: '12px',
          display: 'flex',
          borderRadius: '8px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', gap: '16px' }}>
          <Select
            multiple
            name="activeFlows"
            input={<OutlinedInput id="select-multiple-flows" />}
            onChange={handleActiveFlows}
            value={state.form.activeFlows || []}
            size="small"
            renderValue={selected => (
              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                {selected.map((value: any) => {
                  const flow = filteredFlows?.find(flow => flow.id === value);
                  return (
                    <Chip
                      key={value}
                      sx={{
                        width: 'fit-content',
                        fontSize: '12px',
                        overflow: 'hidden',
                        height: '24px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                      label={flow?.name || 'Untitled Flow'}
                    />
                  );
                })}
              </Box>
            )}
            sx={{
              width: 'fit-content',
              maxWidth: '400px',
            }}
          >
            {filteredFlows?.map(flow => (
              <MenuItem key={flow.id} value={flow.id} title={flow?.name}>
                {flow?.name ? flow?.name : 'Untitled Flow'}
              </MenuItem>
            ))}
          </Select>

          {state.form.status === 'published' && (
            <div
              style={{
                backgroundColor: '#E7F4E8',
                padding: '4px 8px',
                color: '#378D3C',
                fontSize: '14px',
                fontWeight: '400',
                border: '1px solid #80C683',
                borderRadius: '4px',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Published
            </div>
          )}

          {state.form.status === 'draft' && (
            <div
              style={{
                backgroundColor: '#FFF8E0',
                padding: '4px 8px',
                color: '#FDA000',
                fontSize: '14px',
                fontWeight: '400',
                border: '1px solid #FED54D',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Draft
            </div>
          )}

          {state.form.status === 'published' && (
            <div
              style={{
                backgroundColor: '#E7F0FF',
                padding: '4px 8px',
                color: '#3650DE',
                fontSize: '14px',
                fontWeight: '400',
                border: '1px solid #7388F7',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {state.form.publishType === 'internal' ? 'Internal' : 'External'}
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Button
              variant="text"
              onClick={() => {
                setOpenPreviewModal(true);
              }}
              sx={{
                width: '47px',
                height: '47px',
                minWidth: '47px',
                minHeight: '47px',
              }}
            >
              <Eye size={20} color="#475467" />
            </Button>

            <div
              style={{
                width: '1px',
                height: '20px',
                backgroundColor: '#D0D5DD',
              }}
            />

            <Button
              variant="text"
              onClick={() => {
                setSettingsFormMode(true);
                setSelectNode(null);
              }}
              sx={{
                width: '47px',
                height: '47px',
                minWidth: '47px',
                minHeight: '47px',
              }}
            >
              <Gear size={20} color="#475467" />
            </Button>
          </div>

          <Button variant="outlined" onClick={() => setOpenShareModal(true)}>
            Share
          </Button>

          <Button variant="contained" onClick={() => setOpenPublishModal(true)}>
            Publish
          </Button>
        </div>
      </div>

      <PublishModal
        show={openPublishModal}
        onHide={() => setOpenPublishModal(false)}
      />

      <ShareFormModal
        show={openShareModal}
        onHide={() => setOpenShareModal(false)}
      />

      <PreviewModal
        show={openPreviewModal}
        onHide={() => setOpenPreviewModal(false)}
      />
    </>
  );
}
